import React from "react";
import { useLocation } from "react-router-dom";
import BillingCheckoutForm from "./BillingCheckoutForm";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { Helmet } from "react-helmet";

const stripePromise = loadStripe(
  "pk_test_51PLoMQDPGZKo4YmHfEXmkp6w54oeYMczZ92B5bNvST5qj2NFdrAcLHGJAfEh0MmOn2lVxP1xGBlSbiK3zJ7ilgwP004JRyTt9W"
);

function BillingCheckout() {

  const location = useLocation();
  const { plan } = location.state;

  console.log("subscriptionData:", plan);

 

  return (
    
    <Elements stripe={stripePromise}>
       <Helmet>
        <title>PrepNexa – AI-Powered PTE Practice Platform</title>
        <meta
          name="description"
          content="PrepNexa helps you prepare for the PTE exam with AI mock tests, instant scoring, and personalized feedback."
        />
        <meta
          name="keywords"
          content="PrepNexa, PTE prep, AI mock tests, PTE practice, PTE scoring"
        />
      </Helmet>
      <BillingCheckoutForm subscriptionData={plan}/>
    </Elements>
  );
}

export default BillingCheckout;
